import { WltpInfo } from '~/app/market-config';
import { ConfiguredCarTechnicalDataQuery } from '~/graphql/__generated__/graphql';

export function eecDataMerger(wltpInfo: WltpInfo, technicalData: ConfiguredCarTechnicalDataQuery | undefined) {
	if (!wltpInfo) return;
	return {
		...wltpInfo,
		...technicalData?.configuredCar.technicalDataV2?.envkv,
		url: technicalData?.configuredCar.media?.eec?.eecLabelImageUrl
			? {
					url: technicalData?.configuredCar.media?.eec?.eecLabelImageUrl,
					pathParams: {},
					queryParams: [],
				}
			: wltpInfo.url,
	};
}
